export default __webpack_public_path__ + "static/media/Guitar-fretboard.37d24038.png";